export default (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[System]]]', '[[[Ustawienia]]]').after('[[[Konta użytkowników]]]', [
        {
            name: '[[[Oferty pracy - Import]]]',
            route: 'core-erecruiter-settings',
            icon: 'fas fa-fw fa-file-import',
            namespace: 'Ideo.Core.Edito.Application.Permissions.Modules',
            auth: { all: ['ErecruiterPermissions@Manage'], any: [] }
        }

    ]);

    sitemap.find('[[[Moduły]]]').before('[[[Studio]]]', [
        {
            name: '[[[Baza ogłoszeń]]]',
            icon: 'far fa-fw fa-bullhorn',
            namespace: 'Ideo.Core.Edito.Application.Permissions.Modules',
            children: [
                {
                    name: '[[[Ogłoszenia]]]',
                    route: 'int-announcements',
                    icon: 'far fa-fw fa-megaphone',
                    auth: { all: ['AnnouncementsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie ogłoszenia]]]',
                            route: 'int-announcements-add',
                            auth: { all: [], any: ['AnnouncementsPermissions@Edit', 'AnnouncementsPermissions@EditAll'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja ogłoszenia]]]',
                            route: 'int-announcements-edit',
                            auth: { all: [], any: ['AnnouncementsPermissions@Edit', 'AnnouncementsPermissions@EditAll'] },
                            visible: false
                        },
                        {
                            name: '[[[Ustawienia ogłoszeń]]]',
                            route: 'int-announcements-settings',
                            auth: { all: [], any: ['AnnouncementsPermissions@Edit', 'AnnouncementsPermissions@EditAll'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Rodzaje ogłoszeń]]]',
                    route: 'int-announcements-types',
                    icon: 'far fa-fw fa-tags',
                    namespace: 'Ideo.Core.Intranet.Application.Permissions.Modules',
                    auth: { all: ['AnnouncementTypesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie rodzaju]]]',
                            route: 'int-announcements-types-add',
                            auth: { all: ['AnnouncementTypesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja rodzaju]]]',
                            route: 'int-announcements-types-edit',
                            auth: { all: ['AnnouncementTypesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kategorie ogłoszeń]]]',
                    route: 'int-announcements-categories',
                    icon: 'far fa-fw fa-folder-tree',
                    namespace: 'Ideo.Core.Intranet.Application.Permissions.Modules',
                    auth: { all: ['AnnouncementCategoryPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kategorii]]]',
                            route: 'int-announcements-categories-add',
                            auth: { all: ['AnnouncementCategoryPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kategorii]]]',
                            route: 'int-announcements-categories-edit',
                            auth: { all: ['AnnouncementCategoryPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[Erecruiter]]]',
            icon: 'fa-solid fa-globe',
            route: 'cms-erecruiter',
            auth: { all: ['ErecruiterPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie oferty]]]',
                    route: 'cms-erecruiter-add',
                    auth: { all: [], any: ['ErecruiterPermissions@Edit', 'ErecruiterPermissions@EditAll'] },
                    visible: false
                },
                {
                    name: '[[[Edycja oferty]]]',
                    route: 'cms-erecruiter-edit',
                    auth: { all: [], any: ['ErecruiterPermissions@Edit', 'ErecruiterPermissions@EditAll'] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Rezerwacja zasobów]]]',
            icon: 'fa-solid fa-car',
            namespace: 'Ideo.Core.Intranet.Application.Permissions.Modules',
            children: [
                {
                    name: '[[[Lista rezerwacji]]]',
                    route: 'int-reservations',
                    auth: { all: ['ReservationsPermissions@View'], any: [] }
                },
                {
                    name: '[[[Zasoby]]]',
                    route: 'int-reservations-items',
                    auth: { all: ['ReservationsItemsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie zasobu]]]',
                            route: 'int-reservations-items-add',
                            auth: { all: ['ReservationsItemsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja zasobu]]]',
                            route: 'int-reservations-items-edit',
                            auth: { all: ['ReservationsItemsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kategorie zasobów]]]',
                    route: 'int-reservations-categories',
                    auth: { all: ['ReservationsCategoriesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kategorii]]]',
                            route: 'int-reservations-categories-add',
                            auth: { all: ['ReservationsCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kategorii]]]',
                            route: 'int-reservations-categories-edit',
                            auth: { all: ['ReservationsCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[Baza PDF]]]',
            icon: 'fa-solid fa-file-pdf',
            route: 'int-pdfs',
            auth: { all: ['PdfsPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie PDF]]]',
                    route: 'int-pdfs-add',
                    auth: { all: [], any: ['PdfsPermissions@Edit', 'PdfsPermissions@EditAll'] },
                    visible: false
                },
                {
                    name: '[[[Edycja PDF]]]',
                    route: 'int-pdfs-edit',
                    auth: { all: [], any: ['PdfsPermissions@Edit', 'PdfsPermissions@EditAll'] },
                    visible: false
                }
            ]
        }
    ]);
};
